const includes = require("lodash/includes");
const isEqual = require("lodash/isEqual");

const functionMap = {
  isEqual,
  isInArray: includes,
  isNotEqual,
};

export default {
  getters: {
    validatePrerequisiteList: (state, getters, rootState, rootGetters) => (
      prerequisiteList,
      entityId
    ) => {
      if (!(prerequisiteList && entityId)) {
        return true;
      }

      return prerequisiteList.every(rule => {
        const {
          attribute,
          childAttribute,
          childEntity,
          entity,
          operator,
          value: valueTest,
        } = rule;

        // Get entity instance using entity type and id
        const entityInstance = rootGetters[`${entity}/getById`](entityId);

        // Get actual value
        const valueActual = entityInstance[attribute];

        // Return early if FK lookup isn't necessary for validation
        if (!(childAttribute && childEntity)) {
          const isValid = functionMap[operator](valueActual, valueTest);

          return isValid;
        }
        // Use FK - ( current "valueActual" ) - to get child entity instance
        let childEntityInstance = rootGetters[`${childEntity}/getById`](
          valueActual
        );

        // Return if child entity is undefined
        if (!childEntityInstance) {
          return false;
        }

        // Get actual child value
        const childValueActual = childEntityInstance[childAttribute];
        const isValid = functionMap[operator](childValueActual, valueTest);

        return isValid;
      });
    },
  },
  namespaced: true,
};

function isNotEqual(attributeValue, value) {
  return !isEqual(attributeValue, value);
}
